/**
 * Special version of CommonIssuesViewController for Angular upgrade
 * The prefix "zng1-" is required!
 */
namespace h5_client {
   module platform_ui {

      declare const h5: any;
      declare const angular: ng.IAngularStatic;

      export class IssuesViewComponent implements ng.IComponentOptions {

         bindings: any = {
            objectId: "<"
         };

         // Uses legacy template
         template:string='<div class="fill-parent" data-test-id="common-issues-view"> <vx-activity-indicator is-visible="ctrl.pendingRequest" title="{{i18n(\'Common\', \'loadingTitle\')}}"></vx-activity-indicator> <div class="fill-parent"> <div vui-datagrid="ctrl.datagridOptions" vx-stretch-grid class="fill-parent" vx-datagrid-row-right-click="ctrl.showActionsMenu($event)"> </div> </div> </div>';

         controller = h5.ngMigrationResolveController(
            angular.module('com.vmware.platform.ui'), 'CommonIssuesViewController');

         controllerAs = "ctrl";
      }

      angular.module('com.vmware.platform.ui')
         .component('commonIssuesView', new IssuesViewComponent());
   }
}

